<!-- eslint-disable -->
<template lang="pug">
    .tab(
        :class="{'tab_selected': selected, 'tab_disabled': disabled}",
        @click="$emit('select', value)"
    )
        slot
</template>

<script>
    /*eslint-disable*/
    export default {
        props: {
            value: {
                type: [Number, Boolean, String],
                default: undefined,
            },
            selected: {
                type: Boolean,
                default: false,
            },
            disabled: {
                type: Boolean,
                default: false,
            }
        }
    }
</script>

<style scoped lang="scss">
    .tab {
        background: $x-color-white;
        border: 1px solid $hsl-color-blue-56_5;
        box-sizing: border-box;
        border-radius: 5px;
        color: $hsl-color-blue-56_5;
        text-align: center;
        font-size: 16px;
        line-height: 19px;
        padding: 12px 15px;
        cursor: pointer;
        min-width: 40px;
        min-height: 43px;
        white-space: nowrap;
        transition: all .2s ease;
        &:hover {
            background: #D9EAFF;
            color: $hsl-color-blue-56_5;
        }
    }
    .tab_selected {
        background: $hsl-color-blue-56_5;
        color: $x-color-white;
    }
    .tab_disabled {
        background: #EFEFEF;
        border-color: $hsl-color-gray-74;
        color: $hsl-color-gray-52;
        pointer-events: none;
        cursor: auto;
    }
</style>
